import React from 'react'
import {useTranslation} from 'react-i18next';
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Add from '@mui/icons-material/Add'
import Delete from '@mui/icons-material/Delete'
import Remove from '@mui/icons-material/Remove'
import {CartItem, useCartContext} from '../../../context/CartContext';
import {buttonStyle} from '../../../common/constants/buttonStyle';
import {dataLayerButtonClick} from "tracking/events/buttons";

export interface Props {
    item: CartItem
    pageSettings?: any
    disableDeleteButton?: boolean
}

function P015CartItemCounter({item, disableDeleteButton}: Props) {
    const {
        quantity
    } = item;
    const {t} = useTranslation();
    const cartContext = useCartContext()

    const decreaseAriaLabel = `${t('cart.decrease_quantity')} ${quantity - 1}`;
    const increaseAriaLabel = `${t('cart.increase_quantity')} ${quantity + 1}`;
    const removeAriaLabel = `${t('cart.remove_publication')}`;

    return (
        <Box sx={{
            gridColumn: {
                xs: '1 / 3',
                sm: '2 / 3',
            },
            gridRow: '2 / 3',
            display: 'flex',
            gap: '16px',
            justifyContent: 'flex-start',
            alignItems: 'center',
        }}>
            <Box sx={{margin: '0 0 -6px 0'}}>
                <Button data-cypress='removeButton'
                        aria-label={decreaseAriaLabel}
                        disabled={quantity === 1}
                        variant={'contained'}
                        sx={{
                            ...buttonStyle.green,
                            minWidth: {
                                xs: '32px',
                                md: '44px',
                                lg: '48px',
                            },
                            width: {
                                xs: '32px',
                                md: '44px',
                                lg: '48px',
                            },
                            height: {
                                xs: '32px',
                                md: '44px',
                                lg: '48px',
                            },
                        }}
                        onClick={() => cartContext.decreaseItemQuantity(item)}>
                    <Remove/>
                </Button>
            </Box>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <div style={{
                    padding: '0 4px 0 4px',
                    margin: '0 0 -6px 0',
                    fontSize: '0.75rem',
                    lineHeight: '100%',
                    zIndex: 1000,
                    backgroundColor: '#fff',
                }}>
                    {t('cart.count')!}

                </div>
                <Button tabIndex={-1} data-cypress='quantityButton'
                        aria-label={'Quantity'}
                        sx={{
                            padding: '0 14px 0 14px',
                            width: {
                                xs: '64px',
                            },
                            height: {
                                xs: '40px',
                                lg: '56px',
                            },
                            border: '1px solid rgba(0, 0, 0, 0.23)',
                            borderRadius: '4px!important',
                            justifyContent: 'flex-start',
                            fontSize: '1rem',
                            color: 'text.primary',
                        }}>
                    {quantity}
                </Button>
            </Box>
            <Box sx={{margin: '0 0 -6px 0'}}>
                <Button data-cypress='addButton'
                        aria-label={increaseAriaLabel}
                        variant={'contained'}
                        sx={{
                            ...buttonStyle.green,
                            minWidth: {
                                xs: '32px',
                                md: '44px',
                                lg: '48px',
                            },
                            width: {
                                xs: '32px',
                                md: '44px',
                                lg: '48px',
                            },
                            height: {
                                xs: '32px',
                                md: '44px',
                                lg: '48px',
                            },
                        }}
                        onClick={() => cartContext.increaseItemQuantity(item)}>
                    <Add/>
                </Button>
            </Box>
            <Divider orientation={'vertical'} flexItem/>
            {!disableDeleteButton && <Button data-cypress='deleteButton' startIcon={<Delete/>}
                                             onClick={() => {
                                                 dataLayerButtonClick(t('cart.delete_item'), 'cart');
                                                 cartContext.removeFromCart(item);
                                             }}
                                             aria-label={removeAriaLabel}
                                             variant={'contained'}
                                             sx={{
                                                 ...buttonStyle.green,
                                                 fontFamily: '"HelveticaNeueLTStd-Md", Helvetica, Arial, sans-serif',
                                                 fontSize: {xs: '14px', md: '15px'}
                                             }}
            >
                {t('cart.delete_item')!}
            </Button>
            }
        </Box>
    )
}

export default P015CartItemCounter
